/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import {
  deleteContact,
  deleteGroup,
  listRecipients,
  postContact,
  postGroup,
  addRecipientsToGroup,
} from "../api/recipients";

import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Loading from "./Loading";
import { confirmationDialog } from "./ConfirmationDialog";
import { confirmAlert } from "react-confirm-alert";
import RecipientGroupSelector from "./RecipientGroupSelector";

export default class Recipients extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recipients: undefined,
      activeView: "Individual",
      addContactVisible: false,

      selectedRecipients: this.props.existingRecipients
        ? this.props.existingRecipients
        : {
            group: [],
            individual: [],
          },

      filter: undefined,

      newContact: {
        name: "",
        phone: "",
        email: "",
      },

      newGroup: {
        name: "",
        ids: [],
      },
    };
  }

  componentDidMount() {
    listRecipients().then((res) => this.setState({ recipients: res }));
  }

  onAddContact = () => {
    postContact(this.state.newContact.name, {
      code: this.state.newContact.phone.country.dialCode,
      value: this.state.newContact.phone.value,
    }).then((res) => {
      // notify
      this.setState({
        newContact: {
          name: "",
          phone: "",
          email: "",
        },
        addContactVisible: false,
      });
      listRecipients().then((res) => this.setState({ recipients: res }));
    });
  };

  onDeleteContact = (id) => {
    deleteContact(id).then((res) => {
      listRecipients().then((res) => this.setState({ recipients: res }));
    });
  };

  onAddGroup = () => {
    postGroup(this.state.newGroup.name, this.state.newGroup.ids).then((res) => {
      this.setState({
        newGroup: {
          name: "",
          ids: [],
        },
        addContactVisible: false,
      });
      listRecipients().then((res) => this.setState({ recipients: res }));
    });
  };

  onEditGroupContacts = (id) => {
    const group = this.state.recipients.group.filter((g) => g.id === id)[0];

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <RecipientGroupSelector
            onClose={onClose}
            onConfirm={(ids) => {
              addRecipientsToGroup(group.id, ids).then((res) => {
                listRecipients().then((res) =>
                  this.setState({ recipients: res })
                );
              });
            }}
            existingRecipients={group.Recipients.map((r) => r.id)}
          />
        );
      },
    });
  };

  onDeleteGroup = (id) => {
    deleteGroup(id).then((res) => {
      listRecipients().then((res) => this.setState({ recipients: res }));
    });
  };

  render() {
    const renderGroups = () => {
      if (!this.state.recipients) {
        return (
          <div className="main-rec-container mt-4 mb-4 is-flex is-justify-content-center">
            <Loading />
          </div>
        );
      }
      const addGroupForm = () => {
        const validation = () => {
          if (this.state.newGroup.name && this.state.newGroup.name.length > 0) {
            if (
              this.state.recipients.group.filter(
                (g) =>
                  g.name.toUpperCase() ===
                  this.state.newGroup.name.toUpperCase()
              ).length > 0
            ) {
              return "A group with this name already exists.";
            } else {
              return "";
            }
          } else {
            return "Group name can't be empty";
          }
        };

        const valid = validation();

        return (
          <section className="section">
            <label className="label">Name</label>
            <div className="field">
              <div className="control">
                <input
                  className="input "
                  type="text"
                  value={this.state.newGroup.name}
                  onChange={(e) =>
                    this.setState((prevState) => ({
                      newGroup: {
                        ...prevState.newGroup,
                        name: e.target.value,
                      },
                    }))
                  }
                  placeholder="Name"
                />
              </div>
            </div>

            <p
              className={`help is-${valid.length === 0 ? "success" : "danger"}`}
            >
              {valid.length === 0 ? "" : valid}
            </p>

            <div className="field mt-4">
              <div className="control">
                <button
                  className="button is-primary"
                  disabled={valid.length !== 0}
                  onClick={this.onAddGroup}
                >
                  Save Group
                </button>
              </div>
            </div>
          </section>
        );
      };

      const renderGroupTable = () => {
        return (
          <div>
            <div className="">
              <table className="table is-striped is-fullwidth is-hoverable">
                <thead>
                  <tr>
                    <th>Group</th>
                    <th>Recipients</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {this.state.recipients.group.map((r) => (
                    <tr key={r.id}>
                      <th>{r.name}</th>
                      <th>
                        {r.Recipients.length} |{" "}
                        <a
                          onClick={() => {
                            this.onEditGroupContacts(r.id);
                          }}
                        >
                          Edit
                        </a>
                      </th>
                      <th>
                        <a
                          onClick={() => {
                            confirmationDialog(
                              {
                                title: "Delete contact",
                                text:
                                  "Are you sure you want to remove this contact?",
                                positiveText: "Yes",
                                positiveColor: "danger",
                                negativeText: "No",
                                negativeColor: "info",
                              },
                              () => this.onDeleteGroup(r.id)
                            );
                          }}
                        >
                          Remove
                        </a>
                      </th>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      };

      return (
        <>
          <button
            className={`button is-${
              this.state.addContactVisible ? "info" : "primary"
            }`}
            onClick={() =>
              this.setState({
                addContactVisible: !this.state.addContactVisible,
              })
            }
          >
            {this.state.addContactVisible ? "Close" : "Add Group"}
          </button>

          {this.state.addContactVisible && addGroupForm()}

          <div className="mt-4">{renderGroupTable()}</div>
        </>
      );
    };

    const renderContacts = () => {
      if (!this.state.recipients) {
        return (
          <div className="main-rec-container mt-4 mb-4 is-flex is-justify-content-center">
            <Loading />
          </div>
        );
      }

      const addContactForm = () => {
        // const valid =
        //   this.state.newContact.name.length > 0 &&
        //   this.state.newContact.phone.valid;

        const validation = () => {
          if (this.state.newContact.phone) {
            const phoneCompare = `+${this.state.newContact.phone.country.dialCode}${this.state.newContact.phone.value}`;

            const existsPhone =
              this.state.recipients.individual.filter(
                (i) => i.phone === phoneCompare
              ).length > 0;
            if (existsPhone)
              return "A contact with this phone number already exists.";
          }

          if (this.state.newContact.name) {
            const existsName =
              this.state.recipients.individual.filter(
                (i) =>
                  i.name.toUpperCase() ===
                  this.state.newContact.name.toUpperCase()
              ).length > 0;
            if (existsName) return "A contact with this name already exists.";
          }

          if (
            !this.state.newContact.name ||
            this.state.newContact.name.length === 0
          )
            return "The contact name can't be empty.";

          if (
            !this.state.newContact.phone ||
            !this.state.newContact.phone.valid
          )
            return "Invalid phone number.";

          return "";
        };

        const valid = validation();

        return (
          <section className="section">
            <label className="label">Name</label>
            <div className="field">
              <div className="control">
                <input
                  className="input "
                  type="text"
                  value={this.state.newContact.name}
                  onChange={(e) =>
                    this.setState((prevState) => ({
                      newContact: {
                        ...prevState.newContact,
                        name: e.target.value,
                      },
                    }))
                  }
                  placeholder="Name"
                />
              </div>
            </div>

            <label className="label">Phone #</label>
            <div className="field">
              <IntlTelInput
                preferredCountries={["pt"]}
                containerClassName="intl-tel-input field control"
                inputClassName="field"
                onPhoneNumberChange={(valid, value, country) =>
                  this.setState((prevState) => ({
                    newContact: {
                      ...prevState.newContact,
                      phone: { valid: valid, value: value, country: country },
                    },
                  }))
                }
              />
            </div>

            <p
              className={`help is-${valid.length === 0 ? "success" : "danger"}`}
            >
              {valid.length === 0 ? "" : valid}
            </p>

            <div className="field mt-4">
              <div className="control">
                <button
                  className="button is-primary"
                  disabled={valid.length !== 0}
                  onClick={this.onAddContact}
                >
                  Save Contact
                </button>
              </div>
            </div>
          </section>
        );
      };

      const renderContactTable = () => {
        const filter = this.state.filter;
        const rows = filter
          ? this.state.recipients.individual
              .filter(
                (r) =>
                  r.name.toLowerCase().includes(filter.toLowerCase()) ||
                  r.phone.includes(filter)
              )
              .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          : this.state.recipients.individual.sort((a, b) =>
              a.name > b.name ? 1 : b.name > a.name ? -1 : 0
            );

        return (
          <div>
            <input
              className="input mb-2"
              type="text"
              placeholder="Filter by name or phone #"
              onChange={(e) => this.setState({ filter: e.target.value })}
            />

            <div className="">
              <table className="table is-striped is-fullwidth is-hoverable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone #</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {rows.map((r) => (
                    <tr key={r.id}>
                      <th>{r.name}</th>
                      <th>{r.phone}</th>
                      <th>
                        <a
                          onClick={() => {
                            confirmationDialog(
                              {
                                title: "Delete contact",
                                text:
                                  "Are you sure you want to remove this contact?",
                                positiveText: "Yes",
                                positiveColor: "danger",
                                negativeText: "No",
                                negativeColor: "info",
                              },
                              () => this.onDeleteContact(r.id)
                            );
                          }}
                        >
                          Remove
                        </a>
                      </th>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      };

      return (
        <>
          <button
            className={`button is-${
              this.state.addContactVisible ? "info" : "primary"
            }`}
            onClick={() =>
              this.setState({
                addContactVisible: !this.state.addContactVisible,
              })
            }
          >
            {this.state.addContactVisible ? "Close" : "Add Contact"}
          </button>

          {this.state.addContactVisible && addContactForm()}

          <div className="mt-4">{renderContactTable()}</div>
        </>
      );
    };

    return (
      <div>
        <section className="section mx-6">
          <div className="container sie-title-container">
            <h4 className="title">Recipients</h4>
            <h5 className="subtitle">
              Add or remove recipients and manage contact groups
            </h5>
          </div>
        </section>

        <section className="section mx-6">
          <div className="container">
            <div className="tabs">
              <ul>
                <li
                  className={
                    this.state.activeView === "Individual" ? "is-active" : ""
                  }
                >
                  <a
                    onClick={() => this.setState({ activeView: "Individual" })}
                  >
                    Contacts
                  </a>
                </li>
                <li
                  className={
                    this.state.activeView === "Groups" ? "is-active" : ""
                  }
                >
                  <a onClick={() => this.setState({ activeView: "Groups" })}>
                    Groups
                  </a>
                </li>
              </ul>
            </div>

            <div className="mt-6">
              {this.state.activeView === "Groups" && renderGroups()}
              {this.state.activeView === "Individual" && renderContacts()}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
